// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Tooltip$Showside from "./Tooltip.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function PDPOptionButton$SwatchButton(Props) {
  var value = Props.value;
  var disabled = Props.disabled;
  var selected = Props.selected;
  var label = Props.label;
  var showLabelOpt = Props.showLabel;
  var sizeOpt = Props.size;
  var circularOpt = Props.circular;
  var firstOpt = Props.first;
  var lastOpt = Props.last;
  var stopPropagationOpt = Props.stopPropagation;
  var onClick = Props.onClick;
  var onHover = Props.onHover;
  var dataId = Props.dataId;
  var dataTestId = Props.dataTestId;
  var tabIndexOpt = Props.tabIndex;
  var alt = Props.alt;
  var showLabel = showLabelOpt !== undefined ? showLabelOpt : false;
  var size = sizeOpt !== undefined ? sizeOpt : /* Lg */3;
  var circular = circularOpt !== undefined ? circularOpt : false;
  var first = firstOpt !== undefined ? firstOpt : false;
  var last = lastOpt !== undefined ? lastOpt : false;
  var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : true;
  var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : 0;
  EntrypointContext$Showside.use(undefined);
  var match = React.useState(function () {
    return false;
  });
  var setHovering = match[1];
  var hovering = match[0];
  var onClick$1 = function (e) {
    if (stopPropagation) {
      e.preventDefault();
      e.stopPropagation();
    }
    Curry._1(onClick, undefined);
  };
  var spacing;
  switch (size) {
    case /* Xs */0:
      spacing = showLabel ? "m-1 -mt-0.5" : "";
      break;
    case /* Sm */1:
      spacing = showLabel ? "m-1" : "";
      break;
    case /* Md */2:
      spacing = showLabel ? "m-1.5" : "";
      break;
    case /* Lg */3:
    case /* Xl */4:
    case /* Xxl */5:
      spacing = showLabel ? "mr-2 mb-2" : "";
      break;
  }
  var tmp;
  switch (size) {
    case /* Xs */0:
      tmp = Cn.make(["w-8 h-8 border-main", circular ? "" : "rounded-sm"]);
      break;
    case /* Sm */1:
      tmp = Cn.make(["w-10 h-10 border-main", circular ? "" : "rounded"]);
      break;
    case /* Md */2:
      tmp = Cn.make(["w-12 h-12 border-main", circular ? "" : "rounded"]);
      break;
    case /* Lg */3:
      tmp = Cn.make(["w-14 h-14 border-main ring-offset-0"]);
      break;
    case /* Xl */4:
      tmp = "";
      break;
    case /* Xxl */5:
      tmp = Cn.make(["w-24 h-24 border-main ring-offset-0"]);
      break;
  }
  var baseCSS = Cn.make(["inline-block relative cursor-pointer transition-all text-primary duration-300 border-solid overflow-hidden border", tmp, circular ? "rounded-full" : "", size !== 4 ? selected || hovering ? "ring-current ring-1" : "" : selected ? "border-black hover:border-black" : "border-gray-200 hover:border-gray-300"]);
  var tmp$1 = {
    opacity: disabled && !selected ? "0.25" : "1"
  };
  var tmp$2 = size !== 4 ? undefined : "46px";
  if (tmp$2 !== undefined) {
    tmp$1.height = tmp$2;
  }
  var tmp$3 = size !== 4 ? undefined : "46px";
  if (tmp$3 !== undefined) {
    tmp$1.width = tmp$3;
  }
  var style = tmp$1;
  var onMouseEnter = function (e) {
    if (size === /* Lg */3) {
      Curry._1(setHovering, function (param) {
        return true;
      });
    }
    Belt_Option.forEach(onHover, function (onHover) {
      Curry._1(onHover, undefined);
    });
  };
  var onMouseLeave = function (e) {
    if (size !== 3) {
      return;
    } else {
      return Curry._1(setHovering, function (param) {
        return false;
      });
    }
  };
  var direction = first ? last ? /* Bottom */1 : /* BottomLeft */5 : last ? /* BottomRight */4 : /* Bottom */1;
  var tmp$4 = {
    className: CSS$Showside.prefix(Cn.make(["relative inline-block leading-0 flex flex-col items-center justify-center gap-4 text-black", spacing])),
    role: "button",
    tabIndex: tabIndex,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
  if (label !== undefined) {
    tmp$4["aria-label"] = Caml_option.valFromOption(label);
  }
  var tmp$5;
  tmp$5 = typeof value === "number" ? null : value.TAG === /* ImageSwatch */0 ? React.createElement(SmartImg$Showside.make, {
    src: value._0,
    fit: /* Cover */1,
    alt: alt,
    priority: 0
  }) : React.createElement("div", {
    className: CSS$Showside.prefix("absolute inset-0"),
    style: {
      background: value._0
    }
  });
  var tmp$6 = {
    dataDisabled: disabled,
    dataActive: selected,
    children: React.createElement("div", {
      className: CSS$Showside.prefix(baseCSS),
      style: style,
      onClick: onClick$1
    }, tmp$5)
  };
  if (dataTestId !== undefined) {
    tmp$6.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$6.dataId = dataId;
  }
  return React.createElement("div", tmp$4, React.createElement(DataAttribute$Showside.make, tmp$6), label !== undefined && !(size !== 4 || !showLabel) ? React.createElement("span", undefined, label) : null, label !== undefined && label.trim() !== "" ? React.createElement(Tooltip$Showside.make, {
    text: label,
    show: hovering,
    direction: direction
  }) : null);
}
PDPOptionButton$SwatchButton.displayName = "PDPOptionButton.SwatchButton";
var SwatchButton = {
  make: PDPOptionButton$SwatchButton
};
function PDPOptionButton(Props) {
  var label = Props.label;
  var disabled = Props.disabled;
  var selected = Props.selected;
  var icon = Props.icon;
  var sizeOpt = Props.size;
  var styleOpt = Props.style;
  var dataId = Props.dataId;
  var dataTestId = Props.dataTestId;
  var onClick = Props.onClick;
  var tabIndexOpt = Props.tabIndex;
  var size = sizeOpt !== undefined ? sizeOpt : /* Lg */3;
  var style = styleOpt !== undefined ? styleOpt : /* Border */0;
  var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : 0;
  var match = ViewportContext$Showside.use(undefined);
  var onClick$1 = function (e) {
    e.preventDefault();
    e.stopPropagation();
    Curry._1(onClick, undefined);
  };
  var fontSizeCn;
  switch (size) {
    case /* Xs */0:
    case /* Sm */1:
      fontSizeCn = "text-base";
      break;
    case /* Md */2:
      fontSizeCn = "text-lg";
      break;
    case /* Lg */3:
      fontSizeCn = "text-xl";
      break;
    case /* Xl */4:
    case /* Xxl */5:
      fontSizeCn = "text-2xl";
      break;
  }
  var colorCn = style !== 1 ? disabled && !selected ? "bg-black text-black bg-opacity-5 text-opacity-20" : "bg-main text-primary" : "text-primary";
  var border = style !== 1 ? React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["absolute inset-0 border-solid border-primary", selected ? "border-2 opacity-100" : match.isMobile ? "border opacity-15" : "border opacity-5 group-3-hover:opacity-25"]))
  }) : null;
  var className = CSS$Showside.prefix(Cn.make(["inline-flex items-center justify-center", "relative text-center transition-colors duration-200 group-3", "cursor-pointer", size !== 1 ? style !== 1 ? "p-5" : "p-2" : "py-5 px-4", disabled && style === /* NoBorder */1 ? "opacity-25 pointer-events-none" : "", colorCn, fontSizeCn]));
  var tmp = {
    dataDisabled: disabled,
    dataActive: selected,
    children: React.createElement("div", {
      className: className,
      role: "button",
      style: {
        minWidth: size !== 1 ? style !== 1 ? "46px" : "2.5em" : "44px"
      },
      tabIndex: tabIndex,
      onClick: onClick$1
    }, Belt_Option.getWithDefault(icon, null), Belt_Option.mapWithDefault(label, null, function (prim) {
      return prim;
    }), border)
  };
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp.dataId = dataId;
  }
  return React.createElement(DataAttribute$Showside.make, tmp);
}
PDPOptionButton.displayName = "PDPOptionButton";
var make = PDPOptionButton;
export { SwatchButton, make };
/* react Not a pure module */